module.exports = __webpack_public_path__ + "media/Video 128a.2098defb.mp4";